

export enum Modes {
    create = "create",
    view = "view",
    edit = "edit",
    delete = "delete",
    versions = "versions",
}
